var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOfficeAndStationery = function SvgOfficeAndStationery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#970CEB",
    d: "M14 12v1.5H1.75a.75.75 0 0 0-.75.75c0 .416.334.75.75.75H18.5a1.5 1.5 0 0 0 1.5-1.5V9l-.022-.003a3 3 0 0 0-1.637-2.325L8.147 1.575a5.438 5.438 0 0 0-6.778 1.6L.359 4.522a1.792 1.792 0 0 0 1 2.816L2 7.5v3.25c0 .69.56 1.25 1.25 1.25zm0-1.5H3.5V7.875zm2.25 3h-.75v-3c0-.687-.469-1.287-1.137-1.456L1.725 5.884a.297.297 0 0 1-.166-.465l1.01-1.347A3.94 3.94 0 0 1 5.716 2.5c.609 0 1.212.144 1.759.416l10.197 5.096c.453.229.76.666.819 1.163l.009.075v4.253h-2.25z"
  })));
};
export default SvgOfficeAndStationery;